export default __webpack_public_path__ + "static/media/0040.63474f55.png";